/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { TextLink, Typography } from '@neo4j-ndl/react';

import { TextOverflow } from '../TextOverflow';

const Component = () => {
  return (
    <div className="n-max-w-[600px]">
      <TextOverflow
        maxCharacters={50}
        expandButton="view-more"
        shouldShowTooltip={false}
      >
        The{' '}
        <Typography variant="body-medium" className="n-italic n-inline" as="em">
          quick brown fox
        </Typography>{' '}
        jumps over the{' '}
        <TextLink href="#" type="internal-underline">
          lazy dog
        </TextLink>
        . Pack my{' '}
        <Typography
          variant="body-large"
          className="n-font-bold n-inline"
          as="strong"
        >
          box
        </Typography>{' '}
        with five dozen liquor jugs. Waltz,{' '}
        <Typography variant="body-medium" className="n-italic n-inline" as="em">
          bad nymph
        </Typography>
        , for quick jigs vex. The five{' '}
        <TextLink href="#" type="internal-underline">
          boxing wizards
        </TextLink>{' '}
        jump quickly.
      </TextOverflow>
    </div>
  );
};

export default Component;
